import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { T } from "@/data/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "bbm_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("no");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "no" || saved === "en") {
        setLangState(saved);
      }
    } catch (e) {
      /* ignore */
    }
  }, []);

  const setLang = useCallback((next) => {
    if (next !== "no" && next !== "en") return;
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const toggleLang = useCallback(() => {
    setLang(lang === "no" ? "en" : "no");
  }, [lang, setLang]);

  const value = {
    lang,
    setLang,
    toggleLang,
    t: T[lang],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
